import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { format, parseISO } from 'date-fns';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@mui/material';
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { FiAlertTriangle } from "react-icons/fi";

export default function Users() {

    const lottiee = require('../images/lottiee.json');
    const loading = require('../images/loading.json');

    const [show, setShow] = useState(false);
    const [smShow, setSmShow] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [userData, setuserData] = useState([]);
    const [Login_UserName, setLogin_UserName] = useState('');
    const [Login_Password, setLogin_Password] = useState('');
    const [Login_Level, setLogin_Level] = useState('');
    const [updateUser, setupdateUser] = useState({});
    const [loader, setloader] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [editable, setEditable] = useState(false);

    const handleInputClick = () => {
        setEditable(true);
    };

    const filteredData = userData.filter((item) => {
        return (
            item.Login_UserName.toLowerCase().includes(searchQuery.toLowerCase())
        );
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const userList = () => {
      setloader(true)
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        fetch("https://api.padampura.com/LoginList", requestOptions)
          .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result)
                    setuserData(result.data);
                    setloader(false)
                }
            })
            .catch((error) => console.error(error))
            .finally(() => setloader(false))
    }

    const insertUser = () => {
        if (!Login_UserName) {
            alert("Please enter Name");
            return;
        }
        
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "Login_UserName": Login_UserName,
            "Login_Password": Login_Password,
            "Login_Level": Login_Level
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://api.padampura.com/Login_Insert", requestOptions)
         .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result)
                    alert('Insert Successfully')
                    userList();
                } else (
                    alert('Try Again...!!')
                )
            })
            .catch((error) => console.error(error));
    }

    const handleChangeUpdtUser = (e) => {
      const { name, value, type, checked } = e.target;
        setupdateUser({
            ...updateUser,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const editUser = () => {
      const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            ...updateUser
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch(`https://api.padampura.com/Login_Update?MainID=${updateUser.Login_ID}`, requestOptions)
         .then((response) => response.json())
            .then((result) => {
                if (result.status === true) {
                    // console.log(result)
                    alert("Update Successfully")
                    userList();
                } else {
                    alert('Try Again...!!')
                }
            })
            .catch((error) => console.error(error));
    }

    const handleClear = () => {
        setLogin_UserName('');
        setLogin_Password('');
        setLogin_Level('');
    }

    const deleteUser =()=>{
        const requestOptions = {
            method: "DELETE",
            redirect: "follow"
          };
          
          fetch(`https://api.padampura.com/Login_Delete?MainID=${updateUser.Login_ID}`, requestOptions)
           .then((response) => response.json())
            .then((result) => {
                if(result.status === true){
                    // console.log(result)
                    alert('Delete Successfully')
                    userList();
                }else{
                    alert('Something went wrong')
                }
            })
            .catch((error) => console.error(error));
    }

    useEffect(() => {
        userList();
    }, [])

    return (
        <>
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-2 side'>
                        <Sidebar />
                    </div>
                    <div className='col-10 side2'>
                        <Header />
                        <div className='scroll-box'>
                            <div className="container-fluid">
                                <div className='row d-flex justify-content-between mt-2'>
                                  <div className='col-4' style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "1.2em", }} >Users</div>
                                    <div className='col-4'>
                                        <TextField
                                            label="Search User Name"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            sx={{ mb: 0 }}
                                        />
                                    </div>
                                    <div onClick={handleShow} className='col-2 d-flex justify-content-center align-items-center p-1 rounded-1' style={{ backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>+ Add</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12 m-auto">
                                        <div className='card-list-box-sr card p-2 border-0'>
                                            <div className="table-responsive">
                                                <Paper sx={{ width: '100%' }}>
                                                    <TableContainer sx={{ mt: -1 }}>
                                                        <Table stickyHeader aria-label="sticky table" size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Login Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Password</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Level</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    loader ? (
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="center">
                                                                               <div style={{ fontFamily: "Poppins", fontSize: 16 }} >Loading...</div>
                                                                                <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={loading}
                                                                                    style={{ height: '200px', width: '200px' }}
                                                                                >
                                                                                    <Controls visible={false} buttons={['play', 'repeat',]} />
                                                                                </Player>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ) : filteredData.length === 0 ? (
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="center">
                                                                                <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={lottiee}
                                                                                    style={{ height: '100px', width: '100px' }}
                                                                                >
                                                                                    <Controls visible={false} buttons={['play', 'repeat',]} />
                                                                                </Player>
                                                                                <div style={{ fontFamily: "Poppins", fontSize: 16, color: 'red' }} >Data Not Present...</div>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                      : (
                                                                          filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                                                              <TableRow key={index}>
                                                                                  <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.Login_UserName}</TableCell>
                                                                                  <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.Login_Password}</TableCell>
                                                                                  <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.Login_Level == 1 ? "Admin" : item.Login_Level == 2 ? "Manager" : "User"}</TableCell>
                                                                                  <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", }}>
                                                                                      <div className='d-flex justify-content-between' style={{ width: 50, }}>
                                                                                         <FaEdit onClick={() => { handleShow2(); setupdateUser({ ...item }) }} style={{ cursor: "pointer", color: "#566573" }} />
                                                                                         <MdDelete onClick={()=> {setSmShow(true);setupdateUser({...item})}} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                                                      </div>
                                                                                  </TableCell>
                                                                              </TableRow>
                                                                          ))
                                                                      )
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 20]}
                                                        component="div"
                                                        count={userData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                                <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                       <Modal.Title>Add User</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Login Name</div>
                                                                    <input className='sercc-inpt p-1' value={Login_UserName} onChange={(e) => setLogin_UserName(e.target.value)} placeholder="Login Name" autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Password</div>
                                                                    <input className='sercc-inpt p-1' value={Login_Password} onChange={(e) => setLogin_Password(e.target.value)} placeholder="Password" autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                  <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Select Level</div>
                                                                    <select value={Login_Level} onChange={(e) => setLogin_Level(e.target.value)} className="form-select sercc-inpt" aria-label="Default select example">
                                                                        <option selected>Select Level</option>
                                                                        <option value="1">Admin</option>
                                                                        <option value="2">Manager</option>
                                                                        <option value="3">User</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className='row mt-2'>
                                                                <div className='col-2 m-auto'>
                                                                    <div onClick={() => {insertUser();handleClose();handleClear()}} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Save</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                                <Modal show={show2} onHide={handleClose2} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>User's</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                                <div className='col-lg-4 col-md-12 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Login Name</div>
                                                                    <input className='sercc-inpt p-1' name='Login_UserName' value={updateUser.Login_UserName} onChange={handleChangeUpdtUser} placeholder="Login Name" autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Password</div>
                                                                    <input className='sercc-inpt p-1' name='Login_Password' value={updateUser.Login_Password} onChange={handleChangeUpdtUser} placeholder="Password" autoFocus required style={{ width: "100%" }} />
                                                                </div>
                                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                  <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 600 }}>Select Level</div>
                                                                    {editable ? (
                                                                        <select
                                                                            name='Login_Level'
                                                                            value={updateUser.Login_Level}
                                                                            onChange={handleChangeUpdtUser} 
                                                                            className="form-select sercc-inpt"
                                                                            aria-label="Default select example"
                                                                        >
                                                                            <option value="1">Admin</option>
                                                                            <option value="2">Manager</option>
                                                                            <option value="3">User</option>
                                                                        </select>
                                                                    ) : (
                                                                        <input
                                                                            className='sercc-inpt p-1'
                                                                            name='Login_Level'
                                                                            value={updateUser.Login_Level ==1?"Admin":updateUser.Login_Level ==2?"Manager":"User"}
                                                                            onChange={handleChangeUpdtUser}
                                                                            onClick={handleInputClick}
                                                                            readOnly
                                                                            placeholder="Login Name"
                                                                            autoFocus
                                                                            required
                                                                            style={{ width: "100%" }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className='row mt-2'>
                                                                <div className='col-2 m-auto'>
                                                                    <div onClick={() => { handleClose2(); editUser() }} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#2C3E50", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Update</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        <FiAlertTriangle style={{ color: "orangered" }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center align-items-center" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>Are you sure want to Delete ??</div>
                    <div className='d-flex justify-content-between mt-3'>
                        <div onClick={()=> {setSmShow(false);deleteUser()}} className='d-flex justify-content-center align-items-center p-1 rounded-1 me-2' style={{ width: '100%', backgroundColor: "#239B56", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Yes</div>
                        <div onClick={()=> setSmShow(false)} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#E74C3C", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>No</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
